import { createSlice } from "@reduxjs/toolkit";

export const get_disease_type = createSlice({
  name: "crop_disease",
  initialState: {
    value: { status: false, data: {} },
  },
  reducers: {
    updateStoreDiseaseType: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateStoreDiseaseType } = get_disease_type.actions;

export default get_disease_type.reducer;
